import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { AuthenticationService } from './index';
import { IndexConfigService } from './index.config.service';
import { TrustReport } from '../_models/trustReport';
import {Load} from "../_decorators/loading.decorator";
import {LoginHelper} from "../helpers";

@Injectable()
export class TrustReportService {
  public trustReportsUpdated: Subject<TrustReport[]> = new Subject<TrustReport[]>();
  updateList = new Subject();

  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private config: IndexConfigService
  ) {}

  @Load()
  getAllTrustReports(): Observable<TrustReport[]> {
    return this.http.get<TrustReport[]>(`${this.config.api}/api/trustReports`);
  }

  @Load()
  getTrustReportsById(id: number): Observable<TrustReport> {
    return this.http.get<TrustReport>(`${this.config.api}/api/trustReports/${id}`);
  }

  @Load()
  createTrustReport(report: TrustReport): Observable<TrustReport> {
    return this.http.post<TrustReport>(`${this.config.api}/api/trustReports`, report);
  }

  @Load()
  updateTrustReport(report: TrustReport): Observable<TrustReport> {
    return this.http.put<TrustReport>(`${this.config.api}/api/trustReports/${report.id}`, report);
  }

  @Load()
  deleteTrustReport(id: number): Observable<void> {
    return this.http.delete<void>(`${this.config.api}/api/trustReports/${id}`);
  }

  @Load()
  inviteToReport(trustReport: any, inviteText: string) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    return this.http.post<any>(this.config.api + '/api/trustReports/invite', {...trustReport, inviteText: inviteText});
  }

  @Load()
  uploadFile(entity: File) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity);

    return this.http
      .post<any>(this.config.api + '/api/trustReports/upload', formData)
      ;
  }

}
